// Reads the vehicle list managed from /content-admin (VehicleManager),
// which is saved under the same localStorage key as the rest of the panel
// ("motorpro_content_admin_v1", written by pages/content-admin/adminStore.ts).
// Falls back to the static src/data/featuredVehicles.ts list when no
// override list has been saved yet. Read-only here — writing only ever
// happens from the admin panel.

import { useEffect, useState } from "react";
import { featuredVehicles, FeaturedVehicle } from "../data/featuredVehicles";

const CONTENT_STORAGE_KEY = "motorpro_content_admin_v1";
const UPDATE_EVENT = "motorpro-content-updated";

function resolve(): FeaturedVehicle[] {
  try {
    const raw = localStorage.getItem(CONTENT_STORAGE_KEY);
    if (!raw) return featuredVehicles;
    const parsed = JSON.parse(raw);
    const vehicles = parsed?.vehicles;
    if (!Array.isArray(vehicles) || vehicles.length === 0) return featuredVehicles;
    return vehicles.map((v: Partial<FeaturedVehicle> & { id: number; imagePath?: string }) => {
      const original = featuredVehicles.find((f) => f.id === v.id);
      return {
        id: v.id,
        title: v.title || "",
        price: v.price || "",
        location: v.location || "",
        mileage: v.mileage || "",
        badge: v.badge || "",
        url: v.url || "",
        image: original?.image || v.image || "",
      };
    });
  } catch {
    return featuredVehicles;
  }
}

export function useFeaturedVehicles(): FeaturedVehicle[] {
  const [list, setList] = useState<FeaturedVehicle[]>(resolve);
  useEffect(() => {
    const update = () => setList(resolve());
    update();
    window.addEventListener("storage", update);
    window.addEventListener(UPDATE_EVENT, update);
    return () => {
      window.removeEventListener("storage", update);
      window.removeEventListener(UPDATE_EVENT, update);
    };
  }, []);
  return list;
}
